// extracted by mini-css-extract-plugin
module.exports = {"Footnote":"Footnote_Footnote__UtPHy","Footnote--caps":"Footnote_Footnote--caps__gM2Q9"};